import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import BrowserPersistence from "@magento/peregrine/lib/util/simplePersistence";
import { closeDrawer } from "@magento/peregrine/lib/store/actions/app";
import actions from "./actions";
const storage = new BrowserPersistence();
export const beginCheckout = () => async function thunk(dispatch) {
  // Before we begin, reset the state of checkout to clear out stale data.
  dispatch(actions.reset());
  const storedAvailableShippingMethods = await retreiveAvailableShippingMethods();
  const storedBillingAddress = await retrieveBillingAddress();
  const storedPaymentMethod = await retrievePaymentMethod();
  const storedShippingAddress = await retrieveShippingAddress();
  const storedShippingMethod = await retrieveShippingMethod();
  dispatch(actions.begin({
    availableShippingMethods: storedAvailableShippingMethods || [],
    billingAddress: storedBillingAddress,
    paymentCode: storedPaymentMethod && storedPaymentMethod.code,
    paymentData: storedPaymentMethod && storedPaymentMethod.data,
    shippingAddress: storedShippingAddress || {},
    shippingMethod: storedShippingMethod && storedShippingMethod.carrier_code,
    shippingTitle: storedShippingMethod && storedShippingMethod.carrier_title
  }));
};
export const cancelCheckout = () => async function thunk(dispatch) {
  dispatch(actions.reset());
};
export const resetCheckout = () => async function thunk(dispatch) {
  await dispatch(closeDrawer());
  dispatch(actions.reset());
};
export const resetReceipt = () => async function thunk(dispatch) {
  await dispatch(actions.receipt.reset());
};
export const submitPaymentMethodAndBillingAddress = payload => async function thunk(dispatch) {
  const {
    countries,
    formValues
  } = payload;
  const {
    billingAddress,
    paymentMethod
  } = formValues;
  return Promise.all([dispatch(submitBillingAddress({
    billingAddress,
    countries
  })), dispatch(submitPaymentMethod(paymentMethod))]);
};
export const submitBillingAddress = payload => async function thunk(dispatch, getState) {
  dispatch(actions.billingAddress.submit());
  const {
    cart
  } = getState();
  const {
    cartId
  } = cart;
  if (!cartId) {
    throw new Error("Missing required information: cartId");
  }
  try {
    const {
      billingAddress,
      countries
    } = payload;
    let desiredBillingAddress = billingAddress;
    if (!billingAddress.sameAsShippingAddress) {
      desiredBillingAddress = formatAddress(billingAddress, countries);
    }
    await saveBillingAddress(desiredBillingAddress);
    dispatch(actions.billingAddress.accept(desiredBillingAddress));
  } catch (error) {
    dispatch(actions.billingAddress.reject(error));
    throw error;
  }
};
export const submitPaymentMethod = payload => async function thunk(dispatch, getState) {
  dispatch(actions.paymentMethod.submit(payload));
};
export const submitPaymentMethodComponentSelected = payload => async function thunk(dispatch, getState) {
  dispatch(actions.paymentMethodComponentSelected.submit(payload));
};
export const submitAvailablePaymentMethods = payload => async function thunk(dispatch, getState) {
  dispatch(actions.availablePaymentMethods.submit(payload));
};
export const submitShippingAddress = function () {
  let payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return async function thunk(dispatch, getState) {
    dispatch(actions.shippingAddress.submit());
    const {
      formValues,
      countries,
      setGuestEmail,
      setShippingAddressOnCart
    } = payload;
    const {
      cart,
      user
    } = getState();
    const {
      cartId
    } = cart;
    if (!cartId) {
      throw new Error("Missing required information: cartId");
    }
    try {
      const address = formatAddress(formValues, countries);
      if (!user.isSignedIn) {
        if (!formValues.email) {
          throw new Error("Missing required information: email");
        }
        await setGuestEmail({
          variables: {
            cartId,
            email: formValues.email
          }
        });
      }
      const {
        firstname,
        lastname,
        street,
        city,
        region_code,
        postcode,
        telephone,
        country_id
      } = address;
      const {
        data
      } = await setShippingAddressOnCart({
        variables: {
          cartId,
          firstname,
          lastname,
          street,
          city,
          region_code,
          postcode,
          telephone,
          country_id
        }
      });
      // We can get the shipping methods immediately after setting the
      // address. Grab it from the response and put it in the store.
      const shippingMethods = data.setShippingAddressesOnCart.cart.shipping_addresses[0].available_shipping_methods;

      // On success, save to local storage.
      await saveAvailableShippingMethods(shippingMethods);
      await saveShippingAddress(address);
      dispatch(actions.getShippingMethods.receive(shippingMethods));
      dispatch(actions.shippingAddress.accept(address));
    } catch (error) {
      dispatch(actions.shippingAddress.reject(error));
      throw error;
    }
  };
};
export const submitShippingMethod = payload => async function thunk(dispatch, getState) {
  dispatch(actions.shippingMethod.submit());
  const {
    cart
  } = getState();
  const {
    cartId
  } = cart;
  if (!cartId) {
    throw new Error("Missing required information: cartId");
  }
  try {
    const desiredShippingMethod = payload.formValues.shippingMethod;
    await saveShippingMethod(desiredShippingMethod);
    dispatch(actions.shippingMethod.accept(desiredShippingMethod));
  } catch (error) {
    dispatch(actions.shippingMethod.reject(error));
    throw error;
  }
};
export const submitOrder = payload => async function thunk(dispatch) {
  dispatch(actions.receipt.setOrder(payload));
};
export const createAccount = _ref => {
  let {
    history
  } = _ref;
  return async (dispatch, getState) => {
    const {
      checkout
    } = getState();
    const {
      email,
      firstname: firstName,
      lastname: lastName
    } = checkout.receipt.order.shipping_address;
    const accountInfo = {
      email,
      firstName,
      lastName
    };

    // Once we grab what we need from checkout state we can reset.
    await dispatch(resetCheckout());
    history.push("/create-account?".concat(new URLSearchParams(accountInfo)));
  };
};
export const submitPickupPointAvailability = payload => async function thunk(dispatch) {
  dispatch(actions.pickupPointAvailability.submit(payload));
};
export const submitAdyenConfig = payload => async function thunk(dispatch) {
  dispatch(actions.adyenConfig.submit(payload));
};
export const submitAdyenCheckout = payload => async function thunk(dispatch) {
  dispatch(actions.adyenCheckout.submit(payload));
};
export const submitAdyenState = payload => async function thunk(dispatch) {
  dispatch(actions.adyenState.submit(payload));
};
export const submitAdyenAdditionalDetails = payload => async function thunk(dispatch) {
  dispatch(actions.adyenAdditionalDetails.submit(payload));
};
export const submitCheckoutStepCompleted = payload => async function thunk(dispatch) {
  dispatch(actions.checkoutStepCompleted.submit(payload));
};
export const submitTableData = payload => async function thunk(dispatch) {
  dispatch(actions.tableData.submit(payload));
};
export const submitPickupTime = payload => async function thunk(dispatch) {
  dispatch(actions.pickupTime.submit(payload));
};
export const submitStoredShippingData = payload => async function thunk(dispatch) {
  dispatch(actions.storedShippingData.submit(payload));
};
export const submitCoverSKU = payload => async function thunk(dispatch) {
  dispatch(actions.coverSku.submit(payload));
};
export const submitHospitalityData = payload => async function thunk(dispatch) {
  dispatch(actions.hospitalityData.submit(payload));
};
export const submitPayAtStoreSelected = payload => async function thunk(dispatch) {
  dispatch(actions.payAtStoreSelected.submit(payload));
};

/* helpers */

/**
 * Formats an address in the shape the REST API expects.
 * TODO: Can we remove this code once address submissions switch to GraphQL?
 *
 * This function may throw.
 *
 * @param {object} address - The input address.
 * @param {object[]} countries - The list of countries data.
 */
export const formatAddress = function () {
  let address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let countries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const {
    region_code
  } = address;
  const usa = countries.find(_ref2 => {
    let {
      id
    } = _ref2;
    return id === "US";
  });
  const {
    available_regions: regions
  } = usa;
  const region = regions.find(_ref3 => {
    let {
      code
    } = _ref3;
    return code === region_code;
  });
  return _objectSpread({
    country_id: "US",
    region_id: region.id,
    region_code: region.code,
    region: region.name
  }, address);
};
async function clearAvailableShippingMethods() {
  return storage.removeItem("availableShippingMethods");
}
async function retreiveAvailableShippingMethods() {
  return storage.getItem("availableShippingMethods");
}
async function saveAvailableShippingMethods(methods) {
  return storage.setItem("availableShippingMethods", methods);
}
async function clearBillingAddress() {
  return storage.removeItem("billing_address");
}
async function retrieveBillingAddress() {
  return storage.getItem("billing_address");
}
async function saveBillingAddress(address) {
  return storage.setItem("billing_address", address);
}
async function clearPaymentMethod() {
  return storage.removeItem("paymentMethod");
}
async function retrievePaymentMethod() {
  return storage.getItem("paymentMethod");
}
async function savePaymentMethod(method) {
  return storage.setItem("paymentMethod", method);
}
async function clearShippingAddress() {
  return storage.removeItem("shipping_address");
}
async function retrieveShippingAddress() {
  return storage.getItem("shipping_address");
}
async function saveShippingAddress(address) {
  return storage.setItem("shipping_address", address);
}
async function clearShippingMethod() {
  return storage.removeItem("shippingMethod");
}
async function retrieveShippingMethod() {
  return storage.getItem("shippingMethod");
}
async function saveShippingMethod(method) {
  return storage.setItem("shippingMethod", method);
}
export const clearCheckoutDataFromStorage = async () => {
  await clearBillingAddress();
  await clearPaymentMethod();
  await clearShippingAddress();
  await clearShippingMethod();
  await clearAvailableShippingMethods();
};